export default "/images/satellite.png?20de007f7acc24ccedff946b0888a06a";